import React from 'react';
import compose from 'lodash/fp/compose';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { DescriptionSection, ColumnTextBold, ColumnText } from '../styles';
import messages from '../messages';

const PublicationDescription = ({ description }) => {

  const formatDescription = (description) => {
    const descriptionObj = {
      type: intl.formatMessage(messages.noType),
      note: intl.formatMessage(messages.noNote),
    };
    let convertedJSON = {};
    try {
      convertedJSON = JSON.parse(description);
    } catch (e) {
      convertedJSON = { note: description };
    }
    return { ...descriptionObj, ...convertedJSON };
  };

  const getDescriptionComponent = (description) => (
    <DescriptionSection>
      <ColumnTextBold>{description.type}</ColumnTextBold>
      <ColumnText>{description.note}</ColumnText>
    </DescriptionSection>
  );

  const renderDescription = compose(getDescriptionComponent, formatDescription);
  return renderDescription(description);
};

export default PublicationDescription;